module.exports = "mat-icon {\n  cursor: pointer; }\n"